export const SIGN_IN_START = '@AUTH/SIGN_IN_START'
export const SIGN_IN_COMPLETE = '@AUTH/SIGN_IN_COMPLETE'
export const SIGN_IN_ERROR = '@AUTH/SIGN_IN_ERROR'
export const SIGN_OUT = '@AUTH/SIGN_OUT'
export const RESET_SIGN_IN_STATE = '@AUTH/RESET_SIGN_IN_STATE'
export const UPDATE_SIGNED_ACCOUNT_START = '@AUTH/UPDATE_SIGNED_ACCOUNT_START'
export const UPDATE_SIGNED_ACCOUNT_COMPLETE = '@AUTH/UPDATE_SIGNED_ACCOUNT_COMPLETE'
export const UPDATE_SIGNED_ACCOUNT_ERROR = '@AUTH/UPDATE_SIGNED_ACCOUNT_ERROR'
